import RatingGrid from './RatingGrid';

export default RatingGrid;
